import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'lp2-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleBarComponent {
  @Input() pageTitle: String;

  constructor(element: ElementRef) {
    // We have to do this here, since it is an input on a root component
    this.pageTitle = element.nativeElement.getAttribute('page-title');
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/title-bar/title-bar.component.ts